import React from 'react';
import LandingPage from '../Landing';
import SignUp from '../SignUp';

class LandingPage4 extends React.Component {

  render() {
    const headerPosStyle = {
      padding: "10em 0 1em"
    };

    const h2Style = { 
      display: "inline-block",
      color: "#E1E1E1",
      backgroundColor: "#252525",
      fontSize: "40px",
      margin: "0.1em 0.5em 0",
      paddingLeft: "2px",
      paddingRight: "20px",
    };

    const longStyle = {
      marginTop: "0.5em",
      paddingRight: "60px"
    }

    const extraLongStyle = {
      paddingRight: "37px"
    }

    const reverseStyle = {
      backgroundColor: "#E1E1E1",
      color: "#252525"
    }

    return (
      <LandingPage className="landingPage2" bgImg={this.props.bgImg} >

        <div style={headerPosStyle}>
          <p style={ {...h2Style} }>SIGN UP AND</p>
          <p style={ {...h2Style} }>LETS GET</p><br/>
          <p style={ {...h2Style} }>STARTED...</p><br/>
        </div>

        { this.props.children }

      </LandingPage>
    );
  }
}

export default LandingPage4;



// WEBPACK FOOTER //
// ./src/components/LandingPage4/index.js